import styled, { css } from "styled-components";
import { LAYER_COLORS } from "../constants/design/colors";
import { SPACING } from "../constants/design/spacing";

export const ContentsWrapper = styled.div<{
  isMobileScreen?: boolean;
  noWatchList?: boolean;
  noPadding?: boolean;
}>`
  flex: 1;

  ${({ noWatchList, isMobileScreen }) =>
    Boolean(noWatchList && !isMobileScreen) &&
    css`
      grid-column: 2 / span 2;
    `}

  padding: 0 ${({ isMobileScreen, noPadding }) =>
    isMobileScreen || noPadding ? 0 : SPACING.three}px;

  display: flex;
  justify-content: center;
  overflow-y: auto;
  border-radius: 12px;
  background: ${({ isMobileScreen }) => !isMobileScreen && LAYER_COLORS.one};

  ${({ isMobileScreen }) =>
    isMobileScreen &&
    css`
      border-radius: 0;
      max-height: 100%;
    `}
`;

export const InnerContentsWrapper = styled.div<{ isMobileScreen?: boolean }>`
  position: relative;
  width: 100%;
  overflow-x: hidden;
  ${({ isMobileScreen }) => (!isMobileScreen ? "" : "width: 100vw;")}
  display: flex;
  flex-direction: column;
`;

export const RewardsInnerContentsWrapper = styled(InnerContentsWrapper)`
  ${({ isMobileScreen }) =>
    !isMobileScreen
      ? `
    max-width: 750px;
    width: 750px;
    min-width: 0px;
  `
      : `
    width: 100vw;
  `}
`;
